<template>
  <router-view />
</template>

<script>

export default {
  name: "CoursesPage",
}
</script>

<style scoped>

</style>
